import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');
    const googleLogin = params.get('googleLogin');

    if (googleLogin && accessToken) {
      localStorage.setItem('accessToken', accessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
      window.location.href = '/v3/project';
    }
  }, []);

  return (
    <div style={{ margin: 0, padding: 0, background: '#06090F', color: '#EDF0F7', fontFamily: "'Noto Sans KR', sans-serif", overflowX: 'hidden', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Noto+Sans+KR:wght@300;400;500;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        :root {
          --bg: #06090F; --bg2: #0C1018; --bg3: #121820;
          --cyan: #00F0FF; --cyan2: #00C4CC;
          --purple: #7B5FFF; --amber: #FFB800;
          --text: #EDF0F7; --muted: #7A8499; --dim: #3D4455;
          --card: rgba(255,255,255,0.04); --border: rgba(255,255,255,0.08);
        }
        .bebas { font-family: 'Bebas Neue', sans-serif; }
        nav {
          position: fixed; top: 0; left: 0; right: 0; z-index: 100;
          padding: 18px 48px; display: flex; align-items: center; justify-content: space-between;
          background: rgba(6,9,15,0.9); backdrop-filter: blur(16px);
          border-bottom: 1px solid var(--border);
        }
        .logo { font-family: 'Bebas Neue', sans-serif; font-size: 28px; letter-spacing: 2px; color: var(--cyan); display: flex; align-items: center; gap: 8px; cursor: pointer; }
        .logo-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--cyan); }
        .nbtn { padding: 8px 20px; border-radius: 6px; font-size: 13px; font-weight: 500; cursor: pointer; font-family: 'Noto Sans KR', sans-serif; transition: all .2s; }
        .nbtn-o { background: transparent; border: 1px solid var(--border); color: var(--text); }
        .nbtn-o:hover { border-color: var(--cyan); color: var(--cyan); }
        .nbtn-p { background: var(--cyan); border: none; color: #000; font-weight: 700; }
        .nbtn-p:hover { background: #33F4FF; transform: translateY(-1px); }
        .hero {
          min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;
          padding: 120px 48px 80px; text-align: center; position: relative; overflow: hidden;
        }
        .hero-lines {
          position: absolute; inset: 0;
          background: linear-gradient(rgba(0,240,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,240,255,0.05) 1px, transparent 1px);
          background-size: 80px 80px;
          mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
        }
        .hero-glow {
          position: absolute; top: 20%; left: 50%; transform: translateX(-50%);
          width: 600px; height: 300px;
          background: radial-gradient(ellipse, rgba(0,240,255,0.12), transparent 70%);
          pointer-events: none;
        }
        .badge {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 5px 16px; border-radius: 100px;
          background: rgba(0,240,255,0.08); border: 1px solid rgba(0,240,255,0.2);
          font-size: 12px; font-weight: 500; color: var(--cyan); letter-spacing: 1px;
          text-transform: uppercase; margin-bottom: 32px; position: relative; z-index: 1;
        }
        .badge-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--cyan); animation: blink 2s infinite; }
        @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.3} }
        .hero h1 { font-family: 'Bebas Neue', sans-serif; font-size: 88px; line-height: .95; letter-spacing: 2px; margin-bottom: 28px; position: relative; z-index: 1; }
        .line1 { display: block; color: var(--text); }
        .line2 { display: block; color: var(--cyan); text-shadow: 0 0 40px rgba(0,240,255,0.4); }
        .hero p { font-size: 18px; color: var(--muted); line-height: 1.8; max-width: 560px; margin: 0 auto 48px; position: relative; z-index: 1; }
        .hero-btns { display: flex; gap: 16px; justify-content: center; margin-bottom: 72px; position: relative; z-index: 1; }
        .hbtn { padding: 15px 36px; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all .3s; font-family: 'Noto Sans KR', sans-serif; }
        .hbtn-p { background: var(--cyan); color: #000; border: none; }
        .hbtn-p:hover { background: #33F4FF; transform: translateY(-2px); box-shadow: 0 16px 32px rgba(0,240,255,0.25); }
        .hbtn-s { background: transparent; color: var(--text); border: 1px solid var(--border); }
        .hbtn-s:hover { border-color: var(--cyan); color: var(--cyan); }
        .stats { display: flex; gap: 64px; justify-content: center; position: relative; z-index: 1; }
        .stat-n { font-family: 'Bebas Neue', sans-serif; font-size: 44px; color: var(--cyan); display: block; letter-spacing: 1px; }
        .stat-l { font-size: 13px; color: var(--muted); margin-top: 2px; }
        .sec { padding: 100px 48px; max-width: 1200px; margin: 0 auto; }
        .sec-tag { font-size: 11px; font-weight: 700; color: var(--cyan); letter-spacing: 3px; text-transform: uppercase; margin-bottom: 14px; }
        .sec-h { font-family: 'Bebas Neue', sans-serif; font-size: 56px; letter-spacing: 1px; line-height: 1; margin-bottom: 16px; }
        .sec-sub { font-size: 17px; color: var(--muted); line-height: 1.7; max-width: 500px; }
        .steps-bg { background: var(--bg2); padding: 1px 0; }
        .steps { padding: 100px 48px; max-width: 1200px; margin: 0 auto; }
        .steps-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: var(--border); border-radius: 16px; overflow: hidden; margin-top: 60px; }
        .step-item { padding: 40px 28px; background: var(--bg2); }
        .step-num { font-family: 'Bebas Neue', sans-serif; font-size: 64px; color: var(--dim); line-height: 1; margin-bottom: 20px; }
        .step-item:first-child .step-num { color: var(--cyan); }
        .step-icon { font-size: 28px; margin-bottom: 16px; }
        .step-title { font-size: 16px; font-weight: 700; margin-bottom: 10px; }
        .step-desc { font-size: 14px; color: var(--muted); line-height: 1.7; }
        .feat-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; margin-top: 56px; }
        .feat-card { padding: 32px; border-radius: 16px; background: var(--card); border: 1px solid var(--border); transition: all .3s; }
        .feat-card:hover { border-color: rgba(0,240,255,0.2); transform: translateY(-3px); }
        .feat-ico { font-size: 32px; margin-bottom: 18px; }
        .feat-title { font-size: 17px; font-weight: 700; margin-bottom: 10px; }
        .feat-desc { font-size: 14px; color: var(--muted); line-height: 1.7; }
        .feat-badge { display: inline-block; margin-top: 14px; padding: 3px 10px; border-radius: 100px; font-size: 11px; font-weight: 600; background: rgba(0,240,255,0.1); color: var(--cyan); border: 1px solid rgba(0,240,255,0.15); }
        .compare-bg { background: var(--bg2); }
        .compare-wrap { padding: 100px 48px; max-width: 1200px; margin: 0 auto; }
        .compare-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 56px; }
        .cmp-card { padding: 36px; border-radius: 16px; border: 1px solid; }
        .cmp-them { border-color: var(--border); background: var(--card); }
        .cmp-us { border-color: rgba(0,240,255,0.25); background: rgba(0,240,255,0.03); position: relative; }
        .cmp-tag { position: absolute; top: -13px; left: 50%; transform: translateX(-50%); padding: 4px 18px; background: var(--cyan); color: #000; border-radius: 100px; font-size: 11px; font-weight: 800; letter-spacing: 1px; white-space: nowrap; }
        .cmp-label { font-size: 15px; font-weight: 700; color: var(--muted); margin-bottom: 20px; }
        .cmp-us .cmp-label { color: var(--cyan); }
        .cmp-row { display: flex; align-items: center; gap: 12px; padding: 11px 0; border-bottom: 1px solid var(--border); font-size: 14px; }
        .cmp-row:last-child { border-bottom: none; }
        .tok-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 14px; margin-top: 48px; }
        .tok-item { padding: 24px; border-radius: 14px; background: var(--card); border: 1px solid var(--border); text-align: center; }
        .tok-action { font-size: 12px; color: var(--muted); margin-bottom: 8px; }
        .tok-cost { font-family: 'Bebas Neue', sans-serif; font-size: 36px; color: var(--cyan); letter-spacing: 1px; }
        .tok-unit { font-size: 12px; color: var(--muted); margin-top: 4px; }
        .price-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; margin-top: 56px; }
        .price-card { padding: 36px; border-radius: 20px; border: 1px solid var(--border); background: var(--card); position: relative; }
        .price-card.hot { border-color: rgba(0,240,255,0.3); background: rgba(0,240,255,0.03); transform: scale(1.03); }
        .price-hot { position: absolute; top: -13px; left: 50%; transform: translateX(-50%); padding: 4px 18px; background: var(--cyan); color: #000; border-radius: 100px; font-size: 11px; font-weight: 800; white-space: nowrap; }
        .price-name { font-family: 'Bebas Neue', sans-serif; font-size: 26px; letter-spacing: 1px; margin-bottom: 6px; }
        .price-desc { font-size: 13px; color: var(--muted); margin-bottom: 28px; }
        .price-amt { display: flex; align-items: baseline; gap: 4px; margin-bottom: 6px; }
        .price-num { font-family: 'Bebas Neue', sans-serif; font-size: 56px; color: var(--cyan); letter-spacing: 1px; }
        .price-won { font-size: 20px; color: var(--muted); }
        .price-tok { font-size: 13px; color: #4ADE80; font-weight: 600; margin-bottom: 28px; }
        .price-list { list-style: none; display: flex; flex-direction: column; gap: 12px; margin-bottom: 32px; }
        .price-list li { display: flex; align-items: center; gap: 10px; font-size: 14px; }
        .price-list li::before { content: '✓'; color: #4ADE80; font-weight: 700; flex-shrink: 0; }
        .pbtn { width: 100%; padding: 14px; border-radius: 10px; font-size: 14px; font-weight: 700; cursor: pointer; transition: all .2s; font-family: 'Noto Sans KR', sans-serif; }
        .pbtn-p { background: var(--cyan); color: #000; border: none; }
        .pbtn-p:hover { background: #33F4FF; }
        .pbtn-o { background: transparent; color: var(--text); border: 1px solid var(--border); }
        .pbtn-o:hover { border-color: var(--cyan); color: var(--cyan); }
        .cta-wrap { margin: 0 48px 80px; border-radius: 24px; background: linear-gradient(135deg, rgba(0,240,255,0.1), rgba(123,95,255,0.1)); border: 1px solid rgba(0,240,255,0.15); padding: 80px; text-align: center; }
        .cta-wrap h2 { font-family: 'Bebas Neue', sans-serif; font-size: 60px; letter-spacing: 2px; margin-bottom: 16px; }
        .cta-wrap p { font-size: 17px; color: var(--muted); margin-bottom: 36px; }
        .cta-btns { display: flex; gap: 14px; justify-content: center; }
        footer { border-top: 1px solid var(--border); padding: 32px 48px; display: flex; align-items: center; justify-content: space-between; }
        .foot-copy { font-size: 13px; color: var(--muted); }
        .foot-links { display: flex; gap: 24px; }
        .foot-links a { font-size: 13px; color: var(--muted); text-decoration: none; transition: color .2s; }
        .foot-links a:hover { color: var(--text); }
        @keyframes fadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        .fade1{animation:fadeUp .6s .1s both}
        .fade2{animation:fadeUp .6s .2s both}
        .fade3{animation:fadeUp .6s .3s both}
        .fade4{animation:fadeUp .6s .4s both}
      `}</style>

      {/* NAV */}
      <nav>
        <div className="logo" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>
          <div className="logo-dot"></div>AI TUNER X
        </div>
        <div style={{display:'flex',gap:12}}>
          <button className="nbtn nbtn-o" onClick={() => navigate('/login')}>로그인</button>
          <button className="nbtn nbtn-p" onClick={() => navigate('/login')}>무료 시작</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-lines"></div>
        <div className="hero-glow"></div>
        <div className="badge fade1"><span className="badge-dot"></span>AI 영상 자동화 플랫폼</div>
        <h1 className="fade2">
          <span className="line1">영상을</span>
          <span className="line2">AI가 편집한다</span>
          <span className="line1">당신은 창작한다</span>
        </h1>
        <p className="fade3">업로드 하나로 끝. AI가 대사를 추출하고,<br/>롱폼을 편집하고, 숏폼을 자동 생성합니다.</p>
        <div className="hero-btns fade4">
          <button className="hbtn hbtn-p" onClick={() => navigate('/login')}>무료로 시작하기 →</button>
          <button className="hbtn hbtn-s">▶ 데모 보기</button>
        </div>
        <div className="stats fade4">
          {[['10X','편집 속도'],['95%','STT 정확도'],['500','무료 토큰'],['0원','편집자 비용']].map(([n,l]) => (
            <div key={l} style={{textAlign:'center'}}>
              <span className="stat-n">{n}</span>
              <div className="stat-l">{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <div className="steps-bg">
        <div className="steps">
          <div className="sec-tag">작동 방식</div>
          <div className="sec-h">4단계, 그게 전부입니다</div>
          <div className="steps-grid">
            {[
              ['01','📤','영상 업로드','드래그앤드롭으로 촬영 영상을 업로드합니다.'],
              ['02','🎙️','AI 대사 추출 (STT)','WhisperX가 한국어 대사를 95% 정확도로 자동 추출합니다.'],
              ['03','✂️','컷편집','Canvas 타임라인에서 대사 기반 컷편집을 진행합니다.'],
              ['04','⬇️','1차 영상 다운로드','편집 완성본을 확인하고 다운로드합니다.'],
            ].map(([n,ico,t,d]) => (
              <div key={n} className="step-item">
                <div className="step-num">{n}</div>
                <div className="step-icon">{ico}</div>
                <div className="step-title">{t}</div>
                <div className="step-desc">{d}</div>
              </div>
            ))}
          </div>
          <div style={{marginTop:40,padding:'24px 32px',borderRadius:16,border:'1px solid rgba(255,184,0,0.2)',background:'rgba(255,184,0,0.04)',textAlign:'center'}}>
            <div style={{fontSize:12,color:'#FFB400',fontWeight:700,letterSpacing:2,marginBottom:12}}>🚀 COMING SOON</div>
            <div style={{display:'flex',gap:32,justifyContent:'center',flexWrap:'wrap'}}>
              {['Gemini AI 자막 자동 생성','자료화면 자동 삽입','최종 완성 영상 생성'].map(t => (
                <div key={t} style={{fontSize:14,color:'var(--muted)'}}>✦ {t}</div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FEATURES */}
      <div className="sec">
        <div className="sec-tag">핵심 기능</div>
        <div className="sec-h">편집의 모든 것<br/>한 곳에서</div>
        <div className="feat-grid">
          {[
            ['🎙️','AI 대사 추출 (STT)','WhisperX 기반 한국어 특화 음성인식. 30분 영상도 2분 안에 정확한 대사와 타임코드 추출.','한국어 특화'],
            ['✂️','롱폼 자동 편집','대사 기반 컷편집. 누락구간 자동 감지, 파형 시각화, 프레임 단위 정밀 편집 지원.','Canvas 타임라인'],
            ['⚡','숏폼 자동 생성','AI가 롱폼에서 바이럴 가능한 숏폼 시나리오를 자동 설계. 30~60초 최적 구성.','AI 시나리오'],
            ['📝','AI 대본 생성','키워드 입력만으로 유튜브 영상 대본 자동 생성. 도입부부터 마무리까지 구조화.','Claude AI'],
            ['📱','화면 비율 자동 변환','16:9 원본을 9:16(숏츠/릴스), 1:1(인스타) 등 플랫폼별 최적 비율로 자동 변환.','멀티 포맷'],
            ['🪙','토큰 기반 과금','사용한 만큼만 지불. 월정액 없이 필요할 때 충전. 미사용 토큰 영구 이월.','Pay as you go'],
          ].map(([ico,t,d,badge]) => (
            <div key={t} className="feat-card">
              <div className="feat-ico">{ico}</div>
              <div className="feat-title">{t}</div>
              <div className="feat-desc">{d}</div>
              <div className="feat-badge">{badge}</div>
            </div>
          ))}
        </div>
      </div>

      {/* COMPARE */}
      <div className="compare-bg">
        <div className="compare-wrap">
          <div className="sec-tag">비교</div>
          <div className="sec-h">편집자 고용 vs<br/>AI Tuner X</div>
          <div className="compare-grid">
            <div className="cmp-card cmp-them">
              <div className="cmp-label">기존 방식 (편집자 고용)</div>
              {[['⏰','영상 1개 편집에 2~3일 소요'],['💸','건당 10~30만원 편집 비용'],['🔄','수정 요청마다 추가 비용'],['📅','빠른 업로드 일정 맞추기 어려움'],['😤','소통 오류로 의도와 다른 결과']].map(([ico,t]) => (
                <div key={t} className="cmp-row"><span style={{fontSize:16,flexShrink:0}}>{ico}</span>{t}</div>
              ))}
            </div>
            <div className="cmp-card cmp-us">
              <div className="cmp-tag">AI TUNER X</div>
              <div className="cmp-label">AI Tuner X</div>
              {[['⚡','30분 영상 편집에 3~5분'],['🪙','토큰 소모만으로 무제한 편집'],['🔁','수정 무제한, 추가 비용 없음'],['🚀','촬영 당일 바로 업로드 가능'],['🎯','내가 직접 편집 → 의도 100% 반영']].map(([ico,t]) => (
                <div key={t} className="cmp-row"><span style={{fontSize:16,flexShrink:0}}>{ico}</span>{t}</div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* TOKEN */}
      <div className="sec">
        <div className="sec-tag">토큰 소비</div>
        <div className="sec-h">사용한 만큼만</div>
        <div style={{fontSize:15,color:'var(--muted)',marginTop:4,marginBottom:32}}>토큰 단가 55원 · 사용한 기능만 차감</div>
        <div className="tok-grid">
          {[
            {ico:'🎙️',label:'STT 추출',cost:'2토큰/분',desc:'30분 영상 = 60토큰',soon:false},
            {ico:'✂️',label:'1차 영상 생성',cost:'80토큰/개',desc:'컷편집 완성본',soon:false},
            {ico:'📝',label:'대본 생성',cost:'50토큰/개',desc:'AI 대본 자동생성',soon:false},
            {ico:'⚡',label:'숏폼 AI 분석',cost:'150토큰/회',desc:'시나리오 자동생성',soon:false},
            {ico:'🎬',label:'숏폼 영상 생성',cost:'80토큰/개',desc:'30~60초 숏폼',soon:false},
            {ico:'🔍',label:'Gemini 분석',cost:'100토큰/회',desc:'자막/자료화면 분석',soon:true},
            {ico:'🎞️',label:'최종 영상 생성',cost:'80토큰/개',desc:'자막 포함 완성본',soon:true},
          ].map(item => (
            <div key={item.label} className="tok-item" style={{opacity:item.soon?0.45:1}}>
              <div className="tok-action">{item.ico} {item.label}</div>
              {item.soon ? (
                <div style={{fontSize:13,color:'#FFB800',fontWeight:700,margin:'8px 0'}}>🔒 Coming Soon</div>
              ) : (
                <div className="tok-cost">{item.cost}</div>
              )}
              <div className="tok-unit">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* PRICING */}
      <div className="compare-bg">
        <div style={{padding:'100px 48px',maxWidth:1200,margin:'0 auto'}}>
          <div className="sec-tag">요금</div>
          <div className="sec-h">간단한 토큰 충전</div>
          <div style={{fontSize:15,color:'var(--muted)',marginTop:12}}>월정액 없음 · 토큰 단가 55원 · 미사용 토큰 영구 이월 · 환불 불가</div>

          {/* 신규가입 혜택 */}
          <div style={{margin:'32px 0',padding:'20px 28px',borderRadius:14,background:'linear-gradient(135deg,rgba(0,240,255,0.08),rgba(123,95,255,0.08))',border:'1px solid rgba(0,240,255,0.2)',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <div>
              <div style={{fontSize:18,fontWeight:700,color:'var(--text)',marginBottom:4}}>🎉 신규가입 혜택</div>
              <div style={{fontSize:14,color:'var(--muted)'}}>가입 즉시 <span style={{color:'var(--cyan)',fontWeight:700}}>500토큰 무료 지급</span> (27,500원 상당)</div>
            </div>
            <button className="hbtn hbtn-p" style={{padding:'12px 28px',fontSize:14}} onClick={() => navigate('/login')}>무료로 시작하기 →</button>
          </div>

          <div className="price-grid">
            {[
              {name:'Starter',desc:'처음 시작하는 크리에이터',price:'55,000',tokens:'1,000',bonus:'',features:['STT 추출 약 8시간 분량','1차 영상 생성 약 12개','숏폼 생성 약 13개','토큰 영구 이월'],hot:false},
              {name:'Pro',desc:'활발하게 업로드하는 크리에이터',price:'75,000',tokens:'1,500',bonus:'9% 보너스',features:['STT 추출 약 12시간 분량','1차 영상 생성 약 18개','숏폼 생성 약 18개','토큰 영구 이월','우선 처리 지원'],hot:true},
              {name:'Premium',desc:'다수 채널 운영 크리에이터',price:'100,000',tokens:'2,200',bonus:'20% 보너스',features:['STT 추출 약 18시간 분량','1차 영상 생성 약 27개','숏폼 생성 약 27개','토큰 영구 이월','멀티 프로젝트 지원'],hot:false},
            ].map(p => (
              <div key={p.name} className={`price-card${p.hot?' hot':''}`}>
                {p.hot && <div className="price-hot">🔥 가장 인기</div>}
                <div className="price-name">{p.name}</div>
                <div className="price-desc">{p.desc}</div>
                <div className="price-amt"><span className="price-num">{p.price}</span><span className="price-won">원</span></div>
                <div className="price-tok">🪙 {p.tokens} 토큰 지급{p.bonus ? ` (${p.bonus})` : ''}</div>
                <ul className="price-list">{p.features.map(f => <li key={f}>{f}</li>)}</ul>
                <button className={`pbtn ${p.hot?'pbtn-p':'pbtn-o'}`} onClick={() => navigate('/login')}>충전하기</button>
              </div>
            ))}
          </div>
          <div style={{textAlign:'center',marginTop:24,fontSize:13,color:'var(--muted)'}}>
            신규 가입 시 <span style={{color:'var(--cyan)',fontWeight:700}}>500토큰 무료 지급</span> (27,500원 상당) · 미사용 토큰 영구 이월 · 환불 불가
          </div>

          {/* 500토큰으로 할 수 있는 것 */}
          <div style={{marginTop:48}}>
            <div style={{fontSize:14,fontWeight:700,color:'var(--cyan)',marginBottom:16,letterSpacing:1}}>🪙 무료 500토큰으로 할 수 있는 것</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div style={{padding:24,borderRadius:14,background:'var(--card)',border:'1px solid var(--border)'}}>
                <div style={{fontSize:16,fontWeight:700,color:'var(--text)',marginBottom:12}}>✂️ 롱폼 편집 1편 완성</div>
                <div style={{fontSize:13,color:'var(--muted)',lineHeight:2}}>
                  <div>STT 추출 30분 ··· 60토큰</div>
                  <div>1차 영상 생성 ··· 80토큰</div>
                  <div>Gemini 분석 ··· 100토큰</div>
                  <div>최종 영상 생성 ··· 80토큰</div>
                  <div style={{borderTop:'1px solid var(--border)',paddingTop:8,marginTop:4,color:'var(--cyan)',fontWeight:700}}>합계 320토큰 (잔여 180)</div>
                </div>
              </div>
              <div style={{padding:24,borderRadius:14,background:'var(--card)',border:'1px solid var(--border)'}}>
                <div style={{fontSize:16,fontWeight:700,color:'var(--text)',marginBottom:12}}>⚡ 숏폼 2개 생성</div>
                <div style={{fontSize:13,color:'var(--muted)',lineHeight:2}}>
                  <div>숏폼 AI 분석 ··· 150토큰</div>
                  <div>숏폼 영상 생성 x2 ··· 160토큰</div>
                  <div style={{borderTop:'1px solid var(--border)',paddingTop:8,marginTop:4,color:'var(--cyan)',fontWeight:700}}>합계 310토큰 (잔여 190)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="cta-wrap">
        <h2>지금 바로 시작하세요</h2>
        <p>편집자 없이도 프로급 영상을. 토큰 충전 없이 무료로 체험.</p>
        <div className="cta-btns">
          <button className="hbtn hbtn-p" onClick={() => navigate('/login')}>무료로 시작하기 →</button>
          <button className="hbtn hbtn-s">문의하기</button>
        </div>
      </div>

      {/* FOOTER */}
      <footer>
        <div className="logo" style={{fontSize:20}}><div className="logo-dot"></div>AI TUNER X</div>
        <div className="foot-copy">© 2026 AI Tuner X. All rights reserved.</div>
        <div className="foot-links">
          <a href="#">이용약관</a>
          <a href="#">개인정보처리방침</a>
          <a href="#">환불정책</a>
          <a href="#">문의</a>
        </div>
      </footer>
    </div>
  );
}